import { mapState } from "vuex";
let moment = require("moment");

export default {
  data(){
    return{
      bookingFixedWidth: 1023,
      filterTypeToReset: '',
      highlightedBoxStyle: 'border: 1px solid hsl(204, 86%, 60%);',
      highlightedLabelClass: 'has-text-info has-text-weight-bold',
      times: [
        { mil: 0, format: "Anytime" },
        { mil: 8, format: "Morning" },
        { mil: 13, format: "Afternoon" },
        { mil: 18, format: "Evening" },
        { mil: -1, format: "Custom" },
      ],
      timeVal: [0, 'Anytime'],
    };
  },
  methods: {
    clearResults(type){
      // console.log('clear results', type);
      this.showRefreshNotification = false;
      this.toggleMapView(type);
      this.collapseSearchForm(type, false);
    },
    finalizeItemsLoading(type){
      // console.log('finalizeItemsLoading()', type);
      this.loading = false;
      if(this.items){
        this.setTimer(type);
      }
      this.collapseSearchForm(type,false);
      //
      switch(type){
        case 'flight':
          this.$emit('flightSearchEnded');
          break;
        case 'car':
          this.$emit('carSearchEnded');
          break;
        case 'hotel':
          this.$emit('hotelSearchEnded');
          break;
        default:
          this.$emit('flightSearchEnded');
          this.$emit('carSearchEnded');
          this.$emit('hotelSearchEnded');
      }
    },
    setTimer() {
      if (this.refreshTimer != null) {
        clearTimeout(this.refreshTimer)
      }
      this.refreshTimer = setTimeout(this.refreshMessage, this.$appConfig.timeRefresh);
    },
    refreshMessage() {
      this.confirmRefresh();
    },
    confirmRefresh() {
      this.showRefreshNotification = true;
    },
    refreshSearch(type) {
      this.$buefy.toast.open(`Refreshing ${type} search!`);
      clearTimeout(this.refreshTimer);
      this.showRefreshNotification = false;
      this.closeMapView(type);
      this.getData(true);
    },
    collapseSearchForm(type, val){
      let payload ={
        type: type,
        data: val,
      }
      this.$store.dispatch('bookTravel/collapseBookingForms', payload);
    },
    toggleSearchForm(type){
      let val = true;
      if(this.bookTravel.formsCollapsed[type] === true){
        val = false;
      }
      this.collapseSearchForm(type, val);
    },
    toggleSearchLabel(type){
      let label = 'Hide Search';
      if(this.bookTravel.formsCollapsed[type] === true) {
        label = 'Edit Search';
      }
      return label;
    },
    showEditSearchLink(type){
      return this.bookTravel.areResultsOld[type] === false;
    },
    setSearchRecordsStatus(type, value){
      let payload = {
        type: type,
        data: value,
      }
      this.$store.dispatch('bookTravel/setResultsStatus', payload);
    },
    switchMapView(type, val){
      let payload ={
        type: type,
        data: val,
      }
      this.$store.dispatch('bookTravel/switchMapView', payload);
    },
    toggleMapView(type){
      let val = true;
      if(this.bookTravel.showMapView[type] === true){
        val = false;
      }
      this.switchMapView(type, val);
    },
    closeMapView(type){
      this.switchMapView(type, false);
    },
    toggleMapLabel(type){
      let label = 'See Map View';
      if(this.bookTravel.showMapView[type] === true) {
        label = 'Hide Map View';
      }
      return label;
    },
    launchInputErrorDialog(errorMessages){
      // console.log(errorMessages.length);
      let messages;
      if (errorMessages.length > 1){
        messages = this.errorMessages.join('</li><li data-test="error-message">')
        messages = '<li data-test="error-message">' + messages + '</li>'
      }
      else{
        messages = '<p data-test="error-message" style="margin-top: 12px;">' + errorMessages[0] + '</p>'
      }

      this.$buefy.dialog.alert({
        title: 'Error',
        message: messages,
        type: 'is-danger',
        hasIcon: true,
        icon: 'alert-circle-outline',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    compareDate(first, second){
      if (first.legs && second.checkinDate){
        // // console.log(first.legs[0].departingAt.date)
        // // console.log(second.checkinDate)
        return (new Date(first.legs[0].departingAt.date) > new Date(second.checkinDate))
      }
      else if(first.legs && second.pickupInfo){
        // // console.log(first.legs[0].departingAt.date)
        // // console.log(second.pickupInfo.dateTime.date)
        return (new Date(first.legs[0].departingAt.date) > new Date(second.pickupInfo.dateTime.date))
      }
      else if(first.checkinDate && second.pickupInfo){
        // // console.log(first.checkinDate)
        // // console.log(second.pickupInfo.dateTime.date)
        return (new Date(first.checkinDate) > new Date(second.pickupInfo.dateTime.date))
      }
      else{
        return false
      }
    },
    returnPolicyValues(val){
      let policy;

      switch(val){
        case 1:
          policy = 'In Policy Only';
          break;
        case 2:
          policy = 'Manager Notifications';
          break;
        case -1:
          policy = 'Any';
          break;
        default:
          policy = '';
      }

      return policy;
    },
    unusedTicketsMessage(){
      var message = `<b>Heads up!</b> You have unused tickets on: `;

      //message += this.$globals.ticketAirlines.join(', ')
      //message += this.$store.state.bookTravel.vendors.airlines['AA']
      var airline;
      var first = true;
      for (airline of this.$globals.ticketAirlines){
        if (first){
          message += this.$globals.vendors.airlines[airline]
          first = false
          continue;
        }
        message += ', ' + this.$globals.vendors.airlines[airline]
      }

      message += '.'

      return message

    },
    journeyLabel(index) {
      let journeysCount = this.$store.state.bookTravel.expectedUnbundledJourneysCount;
      let label = ' ';
      // If one-way,
      if (journeysCount == 1) {
        return 'One-Way' + label;
      }
      // If roundtrip, show nice names for legs
      if (journeysCount == 2) {
        if (index == 1) {
          return 'Outbound' + label;
        } else if (index == 2) {
          return 'Return' + label;
        }
      }
      // Otherwise just show the leg number
      return 'Leg #' + index
    },
    showPolicyTag(index = 0){
      let journeysCount = this.$store.state.bookTravel.expectedUnbundledJourneysCount;
      let showPolicy = false;

      // If one-way,
      if (journeysCount == 1) {
        showPolicy = true;
      }

      if (journeysCount == 2) {
        if (index == 1) {
          showPolicy = false;
        } else if (index == 2) {
          showPolicy = true;
        }
      }

      // console.log('showPolicyTag()', showPolicy);
      return showPolicy;
    },
    clearBundledSelections() {
      // console.log('clearBundledSelections from mixin')
      this.$store.commit('bookTravel/CLEAR_SELECTED_UNBUNDLED_JOURNEYS');
    },
    appendCustomHeader(form){
      // Using Vanilla JS because Vue refs for some reason not working with customization of the Buefy component
      // select datepickers
      let parent0 = document.querySelector(`.datepickerWithNoArrows.dateIndex_0 .datepicker-header`);
      let sibling0 = document.querySelector('.datepickerWithNoArrows.dateIndex_0 .datepicker-header .pagination');
      //
      let parent1 = document.querySelector(`.datepickerWithNoArrows.dateIndex_1 .datepicker-header`);
      let sibling1 = document.querySelector('.datepickerWithNoArrows.dateIndex_1 .datepicker-header .pagination');

      // create custom header content
      let customHeader0 = document.createElement('div');
      let customHeader1 = document.createElement('div');
      let additionalContent = `<hr class="is-paddingless is-marginless"><span class="mb-5 pt-2">&nbsp;</span>`;

      let classList = `is-hidden-desktop is-hidden-tablet`;

      customHeader0.classList = classList;
      customHeader1.classList = classList;

      if(form === 'flight'){
        customHeader0.innerHTML += 'Selecting: <strong>Departure Date</strong>';
        customHeader1.innerHTML += 'Selecting: <strong>Arrival Date</strong>';
      }
      else if (form === 'car'){
        customHeader0.innerHTML += 'Selecting: <strong>Pick up Date</strong>';
        customHeader1.innerHTML += 'Selecting: <strong>Drop off Date</strong>';
      }

      // add final content
      customHeader0.innerHTML += additionalContent;
      customHeader1.innerHTML += additionalContent;

      parent0.insertBefore(customHeader0, sibling0);
      parent1.insertBefore(customHeader1, sibling1);

    }
  },
  computed: {
    ...mapState(["bookTravel"]),
    bookTrip() {
      let numOfBookingItems = 0;

      let booking = {
        flight:
          Object.keys(this.$store.state.bookTravel.result.flight).length > 0,
        car: Object.keys(this.$store.state.bookTravel.result.car).length > 0,
        hotel:
          Object.keys(this.$store.state.bookTravel.result.hotel).length > 0,
      };

      if (booking.flight) {
        numOfBookingItems++;
      }
      if (booking.car) {
        numOfBookingItems++;
      }
      if (booking.hotel) {
        numOfBookingItems++;
      }

      if (numOfBookingItems > 0) {
        booking.currentlyBooking = true;
        booking.numOfBookings = numOfBookingItems;
      }

      return booking;
    },
    bookingLocation(){

      let location = null;

      if (this.sol.car.pickupLocation) {
        location = this.sol.car.pickupLocation;
      }

      if (this.sol.hotel.location) {
        location = this.sol.hotel.location;
      }

      if (this.sol.flight.destinationAirportCode) {

        location = this.$helpers.findAirportByCode(
          this.sol.flight.destinationAirportCode
        );
        
      }

      return location;

    },
    filterButtonLabel() {
      let label = "All Filters";
      if (this.numOfFiltersUsed > 0) {
        label += ` (${this.numOfFiltersUsed})`;
      }
      return label;
    },
    solutionAll() {
      return this.$store.state.bookTravel.result;
    },
    flightBookingDetails() {
      if (this.bookTrip.flight) {
        return this.$store.state.bookTravel.result.flight;
      } else {
        return null;
      }
    },
    hotelBookingDetails() {
      if (this.bookTrip.hotel) {
        return this.$store.state.bookTravel.result.hotel;
      } else {
        return null;
      }
    },
    carBookingDetails() {
      if (this.bookTrip.car) {
        return this.$store.state.bookTravel.result.car;
      } else {
        return null;
      }
    },
    //Returns the legs of the first (outbound) journey
    firstJourneyLegs() {
      let legs = this.flightBookingDetails?.journeys[0].legs ?? [];
      legs.sort((a, b) => {
        return a.arrivingAt.time > b.arrivingAt.time;
      });
      return legs;
    },
    //Returns the last leg of the first journey
    flightArrivalLeg() {
      let numLegs = this.firstJourneyLegs.length;
      return this.firstJourneyLegs[numLegs - 1];
    },
    //Return the first leg of the second journey (roundtrip return leg)
    flightDepartureLeg() {
      if (this.flightBookingDetails?.journeys.length > 1){
        return this.flightBookingDetails?.journeys[1].legs[0];
      } else return null;
      
    },
    flightArrivalMoment() {
      return moment(
        this.flightArrivalLeg?.arrivingAt.date +
          "T" +
          this.flightArrivalLeg?.arrivingAt.time
      );
    },
    flightDepartureMoment() {
      return moment(
        this.flightDepartureLeg?.departingAt.date +
          "T" +
          this.flightDepartureLeg?.departingAt.time
      );
    },
    flightArrivalDate() {
      return moment(this.flightArrivalLeg?.arrivingAt.date).toDate();
    },
    flightDepartureDate() {
      return moment(this.flightDepartureLeg?.departingAt.date).toDate();
    },
    flightArrivalTime() {
      return this.flightArrivalLeg?.arrivingAt.time;
    },
    flightDepartureTime() {
      return this.flightDepartureLeg?.departingAt.time;
    },
    hotelCheckinDate(){
      return moment(this.hotelBookingDetails.checkinDate).toDate();
    },
    hotelCheckoutDate(){
      return moment(this.hotelBookingDetails.checkoutDate).toDate();
    },
    orderedSegments() {
      let segments = [];

      this.sol.flight?.journeys
        ? (segments["flight"] = this.sol.flight.journeys)
        : (segments["flight"] = false);
      this.sol.hotel?.requestedCurrencyPricing
        ? (segments["hotel"] = this.sol.hotel)
        : (segments["hotel"] = false);
      this.sol.car?.pickupInfo
        ? (segments["car"] = this.sol.car)
        : (segments["car"] = false);

      // .legs[0].departingAt.date
      // .checkinDate
      // .pickupInfo.dateTime.date
      // if(this.sol.flight.journeys){
      //   segments = segments.concat(this.sol.flight.journeys)
      //   //segments.push(this.sol.flight.journeys);
      // }
      // for (let j = 0; j < segments.length; j++) {
      //   if (this.sol.flight.travelPolicy) {
      //     segments[j].travelPolicy = this.sol.flight.travelPolicy
      //   }
      // }
      // if(this.sol.hotel.requestedCurrencyPricing){
      //   if (segments.length != 0){
      //     for (var i = 0; i < segments.length; i++){
      //       if (this.compareDate(segments[i], this.sol.hotel)){
      //         segments.splice(i, 0, this.sol.hotel)
      //         break;
      //       }
      //       else if(i == (segments.length - 1)){
      //         segments.push(this.sol.hotel)
      //         break;
      //       }
      //     }
      //   }
      //   else {
      //     segments.push(this.sol.hotel)
      //   }
      //
      // }
      // if(this.sol.car.pickupInfo){
      //   if (segments.length != 0){
      //     for (let i = 0; i < segments.length; i++){
      //       if (this.compareDate(segments[i], this.sol.car)){
      //         segments.splice(i, 0, this.sol.car)
      //         break;
      //       }
      //       else if(i == (segments.length - 1)){
      //         segments.push(this.sol.car)
      //         break;
      //       }
      //     }
      //   }
      //   else {
      //     segments.push(this.sol.car)
      //   }
      // }
      // no results
      // if (!this.sol.flight.journeys){
      //   segments['flight'] = false;
      // }

      // console.log('segments', segments);
      return segments;
    },
    bookingMessage() {
      let result = {
        message: "Let's Get Going!",
        isBooking: false,
      };

      if (
        this.orderedSegments["flight"] ||
        this.orderedSegments["hotel"] ||
        this.orderedSegments["car"]
      ) {
        result.message = "You're off to a GREAT Trip!";
        result.isBooking = true;
      }
      return result;
    },
    multiLegs() {
      return this.sol.flight.journeys.length > 1;
    },
    isOneWay() {
      return (
        this.$store.getters["bookTravel/getExpectedUnbundledJourneysCount"] ===
        1
      );
    },
    //when adding a booking to an existing pnr
    trip() {
      return this.$store.state.bookTravel.result.trip;
    },
    tripLocator() {
      return this.trip.recordLocator;
    },
    modifyingTrip() {
      if (this.tripLocator) return true;
      else return false;
    },
  },
};
